export const commonWebUiVersion = 'dev';
